var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 67,
    viewBox: "0 0 84 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1252 2.62496C34.5418 1.04163 32.4168 0.166626 30.2085 0.166626H8.66683C4.0835 0.166626 0.375163 3.91663 0.375163 8.49996L0.333496 58.5C0.333496 63.0833 4.0835 66.8333 8.66683 66.8333H75.3335C79.9168 66.8333 83.6668 63.0833 83.6668 58.5V16.8333C83.6668 12.25 79.9168 8.49996 75.3335 8.49996H42.0002L36.1252 2.62496Z",
    fill: "#9B59B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.0ff12f21fc3ffe48704d40ab6f6c2e5f.svg";
export { ForwardRef as ReactComponent };